import styled, { css } from 'styled-components';

export const Base = css`
    text-transform: uppercase;
    overflow-wrap: break-word;
    hyphens: auto;
    color: ${({ color, theme }) => color || theme.neutral_2};
`;

export const HeadingTwo = css`
    ${Base};
    font-size: ${({ theme }) => theme.fontSize_lg};
    font-weight: ${({ theme }) => theme.fontExtraBlack};
    letter-spacing: ${({ theme }) => theme.letterSpacing_md};
    margin-bottom: ${({ theme }) => theme.space_8}px;
    line-height: 45px;
`;

export const HeadingFour = css`
    font-size: ${({ theme }) => theme.fontSize_base};
    font-weight: ${({ theme }) => theme.fontRegular};
    letter-spacing: ${({ theme }) => theme.letterSpacing_xs};
    line-height: 24px;
    color: ${({ color, theme }) => color || theme.neutral_3};
    margin-bottom: ${({ theme }) => theme.space_8}px;
`;

export const HeadingFive = css`
    ${Base};
    font-size: ${({ theme }) => theme.fontSize_sm};
    font-weight: ${({ theme }) => theme.fontSemiBold};
    letter-spacing: ${({ theme }) => theme.letterSpacing_md};
    color: ${({ color, theme }) => color || theme.neutral_3};
    line-height: '18px';
`;

export const DataTitle = css`
    ${Base};
    font-size: ${({ theme }) => theme.fontSize_base};
    font-weight: 500;
    color: ${({ color, theme }) => color || theme.neutral_3};
    text-transform: uppercase;
    line-height: 18px;
`;

export const CategoryTitle = styled.div`
    ${HeadingTwo};
    grid-column: 1 / 3;
    border-bottom: solid 1px ${({ theme }) => theme.neutral_7};
`;
